import React from 'react'

const TextInputWrapper = React.forwardRef((props, ref) => (
  <label className='game-form-label'>
    {props.label}
    <input className='form-control' {...props} ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextInputWrapper
